import { DataBean } from "../DataBean";

export class SignAndApprovalPanel extends DataBean {




    public async getSignAndApprovalPanelCatalog(processType: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSignAndApprovalPanelCatalog_Number", [processType]);
    }

    public async getSignAndApprovalItemCatalog(idSignAndApprovalPanel: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSignAndApprovalItemCatalog_Number", [idSignAndApprovalPanel]);
    }

    public async getSignAndApprovalPanelConstants(id: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSignAndApprovalPanelConstants_Number", [id]);
    }
    public async getSigningDocumentFlowList(idSignAndApprovalPanel: any, documentLocation: any, documentLocationdate: any, idemployee: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "java.util.List_getSigningDocumentFlowList_Number_Number_java.util.Date_Number", [idSignAndApprovalPanel, documentLocation, documentLocationdate, idemployee]);
    }

    public async deleteSignAndApprovalPanel(idSignAndApprovalPanel: number, idEmployee: number, observations: string): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "void_deleteSignAndApprovalPanel_Number_Number_String", [idSignAndApprovalPanel, idEmployee, observations]);
    }

    public async updateSignAndApprovalPanel(bean: any): Promise<any> {
        return this.getCustomService("QuickDataERPCore", "com.quickdataerp.bean.documents.SignAndApprovalPanel_updateSignAndApprovalPanel_com.quickdataerp.bean.documents.SignAndApprovalPanel", [
            {
                "DataBeanProperties": bean,
                "DataBeanName": "com.quickdataerp.bean.documents.SignAndApprovalPanel"
            }
        ]);
    }

}